/**
 * Centralized logging utility with environment-aware behavior
 * - Development: Verbose logging to console
 * - Production: Silent or minimal logging
 */
const isDevelopment = typeof window !== 'undefined'
    ? import.meta.env?.DEV
    : process.env.NODE_ENV === 'development';
const isProduction = typeof window !== 'undefined'
    ? import.meta.env?.PROD
    : process.env.NODE_ENV === 'production';
/**
 * Format log message with context
 */
function formatMessage(level, message, context) {
    const timestamp = new Date().toISOString();
    const prefix = `[${timestamp}] [${level.toUpperCase()}]`;
    if (!context || Object.keys(context).length === 0) {
        return `${prefix} ${message}`;
    }
    const contextStr = JSON.stringify(context, null, 2);
    return `${prefix} ${message}\n${contextStr}`;
}
/**
 * Centralized logger implementation
 */
export const logger = {
    debug: (message, context) => {
        if (isDevelopment) {
            console.debug(formatMessage('debug', message, context));
        }
    },
    info: (message, context) => {
        if (isDevelopment) {
            console.info(formatMessage('info', message, context));
        }
    },
    warn: (message, context) => {
        if (isDevelopment || isProduction) {
            console.warn(formatMessage('warn', message, context));
        }
    },
    error: (message, error, context) => {
        if (isDevelopment || isProduction) {
            const errorContext = {
                ...(context || {}),
            };
            if (error) {
                errorContext.error = error instanceof Error ? error.message : String(error);
            }
            console.error(formatMessage('error', message, errorContext));
        }
    },
};
/**
 * Create a scoped logger with default context
 */
export function createLogger(defaultContext) {
    return {
        debug: (message, context) => logger.debug(message, { ...defaultContext, ...context }),
        info: (message, context) => logger.info(message, { ...defaultContext, ...context }),
        warn: (message, context) => logger.warn(message, { ...defaultContext, ...context }),
        error: (message, error, context) => logger.error(message, error, { ...defaultContext, ...context }),
    };
}
//# sourceMappingURL=logger.js.map